import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import {
    OrgProvider,
    useOrgData,
    useOrgLoading,
} from 'app/contexts/OrganizationContext';
import Loading from 'app/components/MatxLoading';

// OrgLayout is now a thin context + loading wrapper. The legacy pink
// "quick nav" row (OrgQuickNav) and the maxWidth Container have moved
// into OrgWorkspace's unified shell — see docs/PROJECT_FACELIFT.md.
// OrgQuickNav.jsx is left in place as an orphan pending the shared
// cleanup PR; grep for importers before deleting.
const OrgLayoutContent = () => {
    const org = useOrgData();
    const loading = useOrgLoading();

    if (loading || !org) return <Loading />;

    return <Outlet />;
};

const OrgLayout = () => {
    const { orgId } = useParams();
    return (
        <OrgProvider key={orgId} orgId={orgId}>
            <OrgLayoutContent />
        </OrgProvider>
    );
};

export default OrgLayout;
